import React, { useRef } from 'react'
import classNames from 'classnames'
import s from './index.module.scss'

interface Props extends Omit<React.HTMLProps<HTMLInputElement>, 'onChange'> {
    onChange?: (v: string) => void
    error?: string | null
}

const Input: React.FC<Props> = ({ onChange, error, className, ...props }) => {
    const inputRef = useRef<HTMLInputElement>(null)

    const inputOnFocus = () => {
        inputRef.current?.scrollIntoView(true)
    }

    return (
        <div className={classNames(s.wrapper, className)} ref={inputRef}>
            <input onChange={(e) => onChange?.(e.target.value)} onFocus={inputOnFocus} {...props} />
            {error && <p className={s.error}>{error}</p>}
        </div>
    )
}

export default Input
